// src/pages/Enseignants/Attendance/StatsBar.jsx
import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

const Stat = ({ icon: Icon, label, value, className = "" }) => (
  <div className={`flex items-center gap-3 rounded-xl ring-1 ring-slate-200 dark:ring-slate-700 bg-white/80 dark:bg-slate-900/60 px-4 py-3 ${className}`}>
    <Icon className="text-2xl" />
    <div>
      <div className="text-lg font-semibold">{value}</div>
      <div className="text-xs opacity-70">{label}</div>
    </div>
  </div>
);

const StatsBar = ({ present = 0, absent = 0 }) => (
  <div className="grid grid-cols-2 gap-3">
    <Stat icon={FaCheck} label="Présents" value={present} />
    <Stat icon={FaTimes} label="Absents" value={absent} />
  </div>
);

export default StatsBar;
